import type { ReactNode } from "react";

import type { OpenSearchStoreReadiness } from "./get-opensearch-store-readiness";

function getOpenSearchStoreStatusMessage(
    readiness: OpenSearchStoreReadiness | null,
): ReactNode | null {
    if (!readiness) {
        return null;
    }

    switch (readiness.status) {
        case "unconfigured_endpoint":
            return (
                <>
                    OpenSearch is not configured in this environment.{" "}
                    {readiness.message}
                </>
            );
        case "unknown_store":
            return (
                <>
                    Store <strong>{readiness.storeId}</strong> was not found in
                    the Treez dispensary list.
                </>
            );
        case "config_fetch_error":
            return (
                <>
                    Could not load Sell Treez config for store{" "}
                    <strong>{readiness.storeId}</strong>: {readiness.message}
                </>
            );
        case "missing_mso_ids":
            return (
                <>
                    Sell Treez config for store{" "}
                    <strong>{readiness.storeId}</strong> is missing{" "}
                    <strong>mso_store_entity_id</strong> or{" "}
                    <strong>mso_org_id</strong>. Product search stays disabled
                    until both values are present.
                </>
            );
        default:
            return null;
    }
}

export { getOpenSearchStoreStatusMessage };
